module.exports = __webpack_public_path__ + "img/Physics.edeb9104.jpg";